<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-12-03 10:54:43
 * @LastEditTime: 2020-07-07 21:54:26
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="ChoosePaymentMethod">
		<Loading v-if="show"></Loading>
		<div class="ChoosePaymentMethod_container">
			<div class="ChoosePaymentMethod_content">
				<div class="ChoosePaymentMethod_pay_info">
					<div class="payInfo_title">
						<span>支付信息</span>
					</div>
					<div class="payInfo_content">
						<div class="payInfo_applicantInfo">
							<div>报名人信息：</div>
							<div v-if="Object.keys(this.ticketData).length">
								{{ ticketData.User.username }}（{{
                  ticketData.User.userphone
                }}）
							</div>
						</div>
						<div id="meetingInfo">
							<div class="meeting_info commonW">
								<div class="meetingInfo_img" v-if="bannerSrc">
									<img :src="bannerSrc || require('../../assets/banner.jpg')" alt />
								</div>
								<div class="meetingInfo_content">
									<ul class="meetingInfo_content_lists">
										<li class="meetingInfo_lists_item">
											{{ meetingInfo.MeetingTitle }}
										</li>
										<li class="meetingInfo_lists_item">
											<!-- <div>时间：</div> -->
											<div>{{ this.meetingInfo.TimerSpan }}</div>
										</li>
										<li class="meetingInfo_lists_item">
											<!-- 地点： -->
											<div>
												{{ meetingInfo.meetingaddress }}
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div id="moneyDesc" v-if="money_desc" v-html="money_desc"></div>
						<div class="payInfo_fareInfo">
							<div class="fareInfo_content">
								<ul>
									<li class="ticketSpecies">{{ ticketData.TypeName }}</li>
									<li>x{{ ticketData.Limit }}</li>
									<li class="money">¥{{ ticketData.OneMoney }}元</li>
								</ul>
								<ul>
									<li>合计：</li>
									<li class="money">¥{{ ticketData.Money }}元</li>
								</ul>
							</div>
						</div>
						<div class="payInfo_choosePaymentMethod">
							<div class="choosePaymentMethod">
								<div class="choosePaymentMethod_title">
									<h5>选择支付方式</h5>
								</div>
								<div class="payInfo_PaymentMethod">
									<van-radio-group v-model="checked_Pay.paycode">
										<van-cell-group>
											<div v-if="onLineList.length">
												<div class="onLine">线上支付</div>
												<div v-for="(item, index) in onLineList" :key="index">
													<div class="radio_item" v-if="item.paytype>=4">
														<van-cell :title="item.payname" clickable
															@click="checkedPay(item)">
															<p v-html="item.remake"></p>
															<van-radio slot="right-icon" :name="item.paycode" />
														</van-cell>
													</div>
													<div class="radio_item" v-else>
														<img :src="item.paylogo" alt />
														<van-cell :title="item.payname" clickable
															@click="checkedPay(item)">{{ item.remake }}
															<van-radio slot="right-icon" :name="item.paycode" />
														</van-cell>
													</div>
												</div>
											</div>
											<div v-if="underLineList.length">
												<div class="underTheLine">线下支付</div>
												<div v-for="(item, index) in underLineList" :key="index">
													<div class="radio_item">
														<van-cell :title="item.payname" clickable
															@click="checkedPay(item)">
															<p style="text-align: left;" v-html="item.remake"></p>
															<van-radio slot="right-icon" :name="item.paycode" />
														</van-cell>
													</div>
												</div>
											</div>
										</van-cell-group>
									</van-radio-group>
								</div>
								<div class="submit">
									<div class="submitBtn" @click="goPay">
										{{ submitMsg }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer :footInfo="this.footInfo"></Footer>
		<div class="modal" v-show="payShow">
			<div class="modal-close" @click="closePay">
				<img src='../../assets/close.png'>
			</div>
			<div class="modal-con">
				<!--  <div class="QR-code">
          <div id="qrcode"></div>
        </div> -->
				<div class="pay-code">
					<img :src="payCode">
				</div>
				<div class="code-text">
					请用{{checked_Pay.payname}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import html2canvas from 'html2canvas'
	import Loading from '@components/Loading.vue'
	import Footer from '@components/Footer'
	import publicSignup from '../../lib/signUp.js'
	import QRCode from 'qrcodejs2'
	export default {
		name: 'pay',
		components: {
			Loading,
			Footer,
		},
		data() {
			return {
				show: true,
				meetingInfo: {}, //会议基本信息
				bannerSrc: '',
				radio: '1', //单选
				m: '', //会议标识
				muid: '',
				publicTools: {}, //通用publicSignup
				ticketData: {}, // 订票总数据
				payEntitys: [], // 支付方式列表
				onLineList: [], //线上支付列表
				underLineList: [], //线下支付列表
				money_desc: '', //报名费用说明
				checked_Pay: {
					//选中支付方式的数据
					paytype: '',
					paycode: '',
					IsPayRed: '',
					payname: '',
				},
				showSubmitBtn: true, //提交中按钮
				submitMsg: '立即支付',
				orderid: '',
				timer: '',
				fNavShow: true,
				payShow: false,
				payCode: '',
				appid: '',
				openid: '',
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},

			}
		},
		created() {
			const {
				m,
				muid
			} = this.$route.query
			this.m = m
			this.muid = muid
			this.publicTools = new publicSignup()
			this.getMeetinginfo()
			let params = {
				m: this.m,
			}
			console.log(this.$route.query.openid)
			this.GetSignMeetingUserByMu(params)
			this.isWeiXins()
		},

		methods: {
			//判断是否为微信访问
			isWeiXins() {
				var ua = window.navigator.userAgent.toLowerCase()
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					this.initShare()
				}
			},
			//获取appid
			async initShare() {
				try {
					const headRes = await this.$http.csData({
						url: encodeURIComponent(
							window.location.href.replace(location.hash, '')
						),
						m: this.m
					})
					this.appid = headRes.AppId
					console.log(headRes)

					this.openid = this.$route.query.openid
					if (!this.openid || this.openid == 'undefined') {
						this.goAuthorize()
					}
				} catch (err) {
					console.log(err)
				}
			},
			goAuthorize() {
				let _url = window.location.href.split('#')[0]
				let prefix
				if (_url.indexOf('?') > 0) {
					let _urlNew = _url.split('?')[0]
					prefix = encodeURIComponent(_urlNew)
				}
				prefix = encodeURIComponent(_url)

				let suffix = encodeURIComponent(window.location.href.split('#')[1])
				const appid = this.appid
				const redirect_uri = encodeURIComponent(
					window.location.origin +
					'/WxBase/BasePayVueCallback?prefix=' +
					prefix +
					'&suffix=' +
					suffix +
					'&m=' +
					this.m
				)
				window.location.href =
					`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=wqzh089898989010101#wechat_redirect`
			},

			//会议基本信息
			async getMeetinginfo() {
				let opt = {
					m: this.m,
					ch: this.$route.query.ch,
				}
				const res = await this.publicTools.init(opt, this)
				// /console.log(res)
				if (res.Code === 1000) {
					this.footInfo.LogoTxt = res.LogoTxt
					this.footInfo.LogoLink = res.LogoLink
					this.footInfo.LogoImg = res.LogoImg
					this.meetingInfo = res
					this.bannerSrc = res.MeetingLogo
					// if (this.meetingInfo.HomeUrl == null) {
					//   this.fNavShow = false
					// }else{
					//   this.homeUrl = this.meetingInfo.HomeUrl
					// }
				}
			},
			// 获取当前登录账户报名信息接口
			async GetSignMeetingUserByMu(opt) {
				try {
					let res = await this.publicTools.GetSignMeetingUserByMu(opt, this)

					if (res.Code === 1000) {
						if (!this.muid) {
							this.muid = res.CurUserEntity.muid
						}
						let opts = {
							m: this.m,
							muid: Number(this.muid),
						}
						this.init(opts)
						// this.initWX()
					}
				} catch (err) {
					console.log(err)
				}
			},
			// -----
			async init(opt) {
				try {
					let res = await this.$http.InitPayConfig(opt)
					console.log(res)
					if (res.Code === 1000) {
						this.ticketData = res
						this.payEntitys = res.PayEntitys
						//this.orderid = res.Orderid
						for (var i in res.PayEntitys) {
							if (res.PayEntitys[i].paycode) {
								// 线上支付列表
								this.onLineList.push(res.PayEntitys[i])
							} else {
								// 线下支付列表
								this.underLineList.push(res.PayEntitys[i])
							}
						}
						// console.log('订票总数据', res.PayEntitys[0])

						let _payEntitys = res.PayEntitys[0]
						if (_payEntitys) {
							this.checked_Pay.paytype = _payEntitys.paytype
							this.checked_Pay.paycode = _payEntitys.paycode
							this.checked_Pay.IsPayRed = _payEntitys.IsPayRed
						}

						this.money_desc = res.signUp_Set.money_desc
					}
					console.log(
						'线上支付列表',
						this.onLineList,
						'线下支付列表',
						this.underLineList
					)
				} catch (err) {
					console.log(err)
				}
				let _meetingInfoLen = Object.keys(this.meetingInfo).length
				let _ticketDataLen = Object.keys(this.ticketData).length

				if (_meetingInfoLen && _ticketDataLen) {
					this.show = false
				}
			},
			// 去支付
			goPay() {
				if (this.isWeiXin()) {
					this.openid = this.$route.query.openid
				} else {
					this.openid = ''
				}

				if (this.checked_Pay.paycode) {
					if (this.checked_Pay.paytype >= 4) {
						this.$router.push({
							path: '/signup/uploadProof',
							query: {
								m: this.m,
								red: this.$route.query.red
							},
						})
					} else {
						this.submitMsg = '等待支付...'
						let params = {
							m: this.m,
							muid: this.muid,
							openid: this.openid,
							//Orderid: this.ticketData.Orderid,
							PayType: Number(this.checked_Pay.paytype),
							PayCode: this.checked_Pay.paycode,
							IsMobile: this.publicTools.isMobile(),
							IsWxClient: this.isWeiXin(),
						}
						this.pay(params)
					}
				} else {
					this.submitMsg = '跳转中...'
					this.$router.push({
						path: '/signup/signupinfo',
						query: {
							m: this.m
						},
					})
				}
			},
			async pay(params) {
				var _that = this
				if (this.showSubmitBtn) {
					console.log('提交的参数', params)
					this.showSubmitBtn = false
					try {
						let res = await this.$http.CreatePayOrder(params)
						console.log(res)
						if (res.Code === 1000) {
							if (this.checked_Pay.paytype === 1) {
								if (this.checked_Pay.IsPayRed) {
									window.location.href = res.callback_url
								} else {
									//console.log(decodeURIComponent(res.code_url))
									this.payShow = true
									//this.qrcode(decodeURIComponent(res.code_url))
									this.payCode = 'data:image/gif;base64,' + res.code_url
									this.orderid = res.orderid
									_that.timer = setInterval(() => {
										_that.QueryOrder()
									}, 1000)
								}
							} else if (this.checked_Pay.paytype === 3) {
								//微信支付
								this.jsApiCall(res)
								this.orderid = res.orderid
							}
						}
						this.showSubmitMsg()
						this.showSubmitBtn = true
					} catch (err) {
						console.log(err)
					}
				}
			},
			//生成二维码
			qrcode(link) {
				new QRCode('qrcode', {
					width: 210,
					height: 210, // 高度
					text: link, // 二维码内容
					render: 'table', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			closePay() {
				this.payShow = false
				this.submitMsg = '立即支付'
			},
			/**
			 * 微信支付
			 */

			jsApiCall(par) {
				if (this.isWeiXin()) {
					var _that = this
					window.WeixinJSBridge.invoke(
						'getBrandWCPayRequest',
						par.payParm,
						function(res) {
							window.WeixinJSBridge.log(res.err_msg)
							if (res.err_msg == 'get_brand_wcpay_request:ok') {
								console.log('res', res)

								_that.timer = setInterval(() => {
									_that.QueryOrder()
								}, 1000)
							} else {
								_that.$notify({
									massage: '您已取消支付',
									type: 'danger',
									duration: '5000',
								})
								console.log('error', res)
							}
						}
					)
				} else {
					if (par.mweb_url) {
						window.location.href = par.mweb_url
					} else {
						this.$notify({
							massage: par.Msg,
							type: 'danger',
						})
					}
				}
			},

			//查询订单是否支付状态
			async QueryOrder() {
				try {
					let params = {
						m: this.m,
						orderid: this.orderid,
					}
					let _Res = await this.$http.QueryOrder(params)

					if (_Res.Code === 1000) {
						clearInterval(this.timer)
						this.$router.push({
							path: '/signup/meetingsignup',
							//query: { m: this.m },
							query: this.$route.query
						})
					} else {
						this.$notify({
							massage: _Res.Msg,
							type: 'danger',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},

			// 选择支付方式
			checkedPay(item) {
				this.checked_Pay.paytype = item.paytype
				this.checked_Pay.paycode = item.paycode
				this.checked_Pay.IsPayRed = item.IsPayRed
				this.checked_Pay.payname = item.payname
				this.showSubmitMsg()
			},
			showSubmitMsg() {
				if (!this.checked_Pay.paycode) {
					this.submitMsg = '确定'
				} else {
					this.submitMsg = '立即支付'
				}
			},
			//判断是否为微信访问
			isWeiXin() {
				//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
				var ua = window.navigator.userAgent.toLowerCase()
				//通过正则表达式匹配ua中是否含有MicroMessenger字符串
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true
				} else {
					return false
				}
			},
		},
	}
</script>
<style lang="scss">
	#ChoosePaymentMethod {
		.payInfo_PaymentMethod {
			.van-radio-group {
				.van-cell__title {
					flex: none;

					>span {
						font-size: 30px;
						line-height: 60px;
					}
				}

				.van-cell__value {
					flex: 1;
					padding: 0 20px;
					position: static;
					text-align: center;
					font-size: 28px;
					line-height: 60px;
				}

				.van-radio__icon {
					height: 60px;
					text-align: center;
				}

				.van-icon {
					font-size: 28px;
					line-height: initial;
					margin-top: 40%;
				}
			}

			.van-hairline--top-bottom {
				position: static;
			}
		}

		.van-dialog {
			width: 70%;
			text-align: center;
			font-size: 32px;
			padding-top: 20px;

			.van-dialog__content {
				margin: 20px;
			}

			.van-button {
				font-size: 32px;
				line-height: 60px;
				height: 60px;
			}
		}
	}
</style>
<style lang="scss" scoped>
	#ChoosePaymentMethod {
		width: 100%;
		font-size: 28px;
		background: #ffffff;
		min-height: 100vh;

		.ChoosePaymentMethod_content {
			padding: 40px 0;

			.ChoosePaymentMethod_pay_info {
				width: 94%;
				margin: 0 auto;
				margin-bottom: 80px;
				box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
				background-color: #ffffff;

				.payInfo_title {
					text-align: center;
					height: 100px;
					line-height: 100px;
					font-size: 32px;
					border-bottom: 2px solid #e2e8f0;
				}

				.payInfo_content {
					width: 94%;
					margin: 0 auto;
					padding-bottom: 20px;

					.payInfo_applicantInfo {
						display: flex;
						justify-content: space-between;
						flex-direction: row;
						flex-wrap: nowrap;
						height: 100px;
						line-height: 100px;
						border-bottom: 1px solid #e2e8f0;
						margin-bottom: 40px;
					}

					#moneyDesc {
						padding: 20px;
						box-shadow: 0 2px 12px rgba(0,0,0,0.04);
					}

					#meetingInfo {
						.meeting_info {
							box-sizing: border-box;
							margin: 40px auto;
							padding: 20px;
							background: #fff;
							box-shadow: 0 2px 12px rgba(0,0,0,0.04);
							display: flex;

							.meetingInfo_img {
								width: 200px;
								height: 200px;
								margin-right: 44px;

								>img {
									width: 100%;
									height: 100%;
								}
							}

							.meetingInfo_content {
								flex: 1;
								font-size: 26px;
								margin-right: 20px;
								padding-top: 10px;
								box-sizing: border-box;

								.meetingInfo_content_lists {
									.meetingInfo_lists_item {
										line-height: 40px;
										color: #64748b;
										overflow: hidden;
										display: flex;

										&:first-child {
											color: #1e293b;
											margin-bottom: 10px;
										}

										// > div:first-child {
										//   width: 80px;
										// }
										>div:last-child {
											flex: 1;
										}
									}
								}
							}
						}
					}

					.payInfo_fareInfo {
						.fareInfo_content {
							margin: 40px 0 60px 0;
							box-shadow: 0 2px 12px rgba(0,0,0,0.04);
							padding: 0 20px;

							>ul {
								display: flex;
								flex-wrap: nowrap;
								flex-direction: row;
								justify-content: space-between;
								align-items: center;

								>li {
									display: flex;
									align-items: center;
									height: 80px;
									line-height: 30px;
									color: #1e293b;
									font-size: 26px;
									padding: 0 5px;
								}

								.money {
									color: #e6a23c;
									// width: 100px;
									justify-content: flex-end;
								}

								&:nth-child(n + 2) {
									border-top: 2px solid #e2e8f0;
								}
							}
						}
					}

					.payInfo_choosePaymentMethod {
						font-size: 32px;
						margin: 60px 0;
						padding-top: 10px;

						.choosePaymentMethod_title {
							>h5 {
								border-bottom: 1px solid #e2e8f0;
								padding-bottom: 8px;
							}
						}

						.underTheLine,
						.onLine {
							font-size: 26px;
							height: 60px;
							line-height: 60px;
							color: #64748b;
						}

						.radio_item {
							display: flex;
							align-items: center;
							padding: 4px 4px;
							border-bottom: 1px solid #e2e8f0;
							justify-content: center;

							>img {
								width: 64px;
								height: 64px;
							}
						}

						.submit {
							margin-top: 80px;

							.submitBtn {
								height: 80px;
								line-height: 80px;
								background-color: #3b82f6;
								color: #fff;
								text-align: center;
							}
						}
					}
				}
			}
		}
	}

	.modal {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, .5);
		z-index: 1000;

		.modal-close {
			position: absolute;
			right: 20px;
			top: 20px;
			color: #fff;
			z-index: 1001;

			img {
				width: 40px;
				height: 40px;
			}
		}

		.modal-con {
			position: absolute;
			left: 50%;
			top: 50%;
			width: 400px;
			height: 460px;
			transform: translate(-50%, -50%);
			background: #fff;

			.pay-code {
				width: 400px;
				height: 400px;

				img {
					width: 400px;
					height: 400px;
				}
			}

			.QR-code {
				width: 400px;
				height: 420px;

				#qrcode {
					width: 400px;
					height: 400px;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.code-text {
				text-align: center;

			}
		}
	}
</style>
